<script>
  export default {
    props: ['shipment', 'submit'],
    data() {
      return {
        forceLockButton: false,
        validators: {
          fba_id: {
            valid: null,
            regexp: /^[a-zA-Z0-9]{6,20}$/,
            validator: 'fba_id',
          },
          fnsku_labels: {
            valid: null,
            validator: 'fnsku_labels',
            valid_size: null,
          },
          shipping_labels: {
            valid: null,
            validator: 'shipping_labels',
            valid_size: null,
          },
          pallet_labels: {
            validator: 'pallet_labels',
            valid_size: null,
          },
        },
      };
    },
    computed: {
      isButtonActive() {
        if (this.forceLockButton) return false;
        const validItems = Object.keys(this.validators).filter((key) => (
          this.validators[key].valid === true
        )).length;
        const validCount = Object.values(this.validators).map((value) => 'valid' in value)
          .filter(Boolean).length;
        return validItems === validCount;
      },
    },
    filters: {
      setLabelName(name) {
        const maxLength = 25;

        return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
      },
    },
    methods: {
      loadLabelFile(event, labelType) {
        const form = new FormData();
        const file = event.target.files[0];

        if (((file.size / 1024) / 1024).toFixed(4) > 2) {
          this.validators[labelType].valid_size = false;
          if (labelType === 'fnsku_labels' || labelType === 'shipping_labels') this.validators[labelType].valid = false;

          this.shipment[`${labelType}_link`] = null;
          return;
        }

        this.validators[labelType].valid_size = true;

        form.append('file', file);
        this.$store.dispatch('files/upload_label', { form })
          .then((data) => {
            const { id, url, name } = data;

            if (labelType === 'fnsku_labels') {
              this.shipment.fnsku_label_id = id;
              this.shipment.fnsku_labels_link = url;
              this.shipment.fnsku_labels_name = name;
            }

            if (labelType === 'shipping_labels') {
              this.shipment.shipping_label_id = id;
              this.shipment.shipping_labels_link = url;
              this.shipment.shipping_labels_name = name;
            }

            if (labelType === 'pallet_labels') {
              this.shipment.pallet_label_id = id;
              this.shipment.pallet_labels_link = url;
              this.shipment.pallet_labels_name = name;
            }

            this.validators[labelType].valid = true;

            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Label was loaded.' });
          })
          .catch(() => {
            this.validators[labelType].valid = false;
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Label wasn\'t loaded. Please try again.' });
          });
      },
      submitAction() {
        const context = {
          id: this.shipment.id,
          form: {
            fba_id: this.shipment.fba_id,
            fnsku_label_id: this.shipment.fnsku_label_id,
            shipping_label_id: this.shipment.shipping_label_id,
            pallet_label_id: this.shipment.pallet_label_id,
          },
        };

        this.forceLockButton = true;
        this.submit(context, () => {
          this.forceLockButton = false;
        });
      },
      validate(event, type) {
        this.validators[type].valid = this.validators[type].regexp.test(event.target.value);
      },
    },
  };
</script>
<template src="./create_shipment.pug" lang="pug"></template>
